import React from 'react'
import { connect } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import FirmwareUpdateDialog from './FirmwareUpdateDialog'
import { webSerialDisconnect } from '../../../redux/actions'

// Pages that render their own FirmwareUpdateDialog wired to this same
// redux state — skip the global dialog there to avoid showing it twice.
const ROUTES_WITH_OWN_DIALOG = ['/deviceSelection', '/advanceSettingv1.0']

function GlobalFirmwareCheck({
    firmwareUpdateDialog,
    hideFirmwareUpdateDialog,
    setUserIgnoredFirmwareUpdate,
    worker,
    disconnectDevice,
}) {
    const history = useHistory()
    const location = useLocation()

    const currentDevice = sessionStorage.getItem('connectedDevice')
    const currentVersion = sessionStorage.getItem('deviceVersion')

    const handleUpdate = () => {
        const firmwareCheck = firmwareUpdateDialog?.firmwareCheck
        hideFirmwareUpdateDialog()
        if (firmwareCheck?.firmwarePath) {
            sessionStorage.setItem(
                'pendingFirmwareUpdate',
                JSON.stringify(firmwareCheck)
            )
        }
        history.push('/deviceSelection')
    }

    const handleSkip = () => {
        const firmwareKey = `${currentDevice}:${currentVersion}`
        setUserIgnoredFirmwareUpdate(firmwareKey)
        hideFirmwareUpdateDialog()
    }

    // Closing the dialog disconnects the device.
    const handleClose = () => {
        hideFirmwareUpdateDialog()
        if (worker) worker.postMessage({ type: 'disconnected' })
        disconnectDevice()
    }

    if (ROUTES_WITH_OWN_DIALOG.includes(location.pathname)) {
        return null
    }

    return (
        <FirmwareUpdateDialog
            isOpen={firmwareUpdateDialog?.isOpen}
            currentVersion={firmwareUpdateDialog?.currentVersion}
            latestVersion={firmwareUpdateDialog?.latestVersion}
            deviceName={firmwareUpdateDialog?.deviceName}
            mandatory={firmwareUpdateDialog?.firmwareCheck?.mandatory}
            onUpdate={handleUpdate}
            onSkip={handleSkip}
            onClose={handleClose}
        />
    )
}

const mapStateToProps = (state) => ({
    firmwareUpdateDialog: state.firmwareUpdateDialog,
    worker: state.worker,
})

const mapDispatchToProps = (dispatch) => ({
    disconnectDevice: () => dispatch(webSerialDisconnect()),
    hideFirmwareUpdateDialog: () =>
        dispatch({ type: 'HIDE_FIRMWARE_UPDATE_DIALOG' }),
    setUserIgnoredFirmwareUpdate: (firmwareKey) =>
        dispatch({ type: 'USER_IGNORED_FIRMWARE_UPDATE', payload: firmwareKey }),
})

export default connect(mapStateToProps, mapDispatchToProps)(GlobalFirmwareCheck)
